import { render, staticRenderFns } from "./EditEventTemplate.vue?vue&type=template&id=64723085&scoped=true&"
import script from "./EditEventTemplate.vue?vue&type=script&lang=js&"
export * from "./EditEventTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64723085",
  null
  
)

export default component.exports